import React from 'react'
import './deliver-company.scss'
import { IExpressCompany, expressCompanyList } from './deliver-company-info'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import useBemClass from '@/utils/hooks/useBEMClass'
import classnams from 'classnames'

interface DeliverCompanyProps {
    selectCompanyId?: string
    onSelect: (company: IExpressCompany) => void
}

const DeliverCompany: React.FC<DeliverCompanyProps> = props => {
    const cls = useBemClass('deliver-company')

    return (
        <BaseDialog
            isShow
            onClose={() => {
                layerManage.pop()
            }}
            title="选择快递物流"
        >
            <div className={cls('container')}>
                {expressCompanyList.map(express => (
                    <div
                        key={express.id}
                        className={classnams(cls('tag'), {
                            [cls('tag', 'active')]: props.selectCompanyId === express.id,
                        })}
                        onClick={() => {
                            props.onSelect(express)
                            layerManage.pop()
                        }}
                    >
                        <img alt="" src={express.img} className="img" />
                        {express.name}
                    </div>
                ))}
            </div>
        </BaseDialog>
    )
}

export default DeliverCompany
